<template>
  <a-modal v-model="openModal" @cancel="$emit('close')" centered width="80vw" :footer="null">
    <div class="mt-4 row">
      <header class="col-12 border-bottom" style="height: 80px">
        <div class="d-flex align-items-center h-100">
          <i class="mdi mdi-chevron-left mr-2" style="font-size: 2rem;"></i>
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="d-flex flex-column justify-content-center">
              <span class="h3 m-0">Nombre del trámite</span>
              <span class="h5 m-0">Tipo de trámite</span>
            </div>
            <div class="shape-button mr-2">Estados</div>
          </div>
        </div>
      </header>
      <div class="col-12 h-100">
        <div class="row h-100">
          <div class="col-11 p-4">
            <div class="d-flex flex-column h-100">
              <a-popover title="Información General" :trigger="['click']">
                <template slot="content">
                  <div class="d-flex flex-column gap-1">
                    <span class="d-flex align-items-center gap-2">
                      <label>
                        <a-switch size="small" v-model="value.header.showCoverPageButton" />
                        Mostrar botón "Carátula"
                      </label>
                    </span>
                    <span class="d-flex align-items-center gap-2">
                      <label>
                        <a-switch size="small" v-model="value.header.showInitiatorButton" />
                        Mostrar botón "Iniciador"
                      </label>
                    </span>
                    <span class="d-flex align-items-center gap-2">
                      <label>
                        <a-switch size="small" v-model="value.header.showUpdateCoverPageButton" />
                        Mostrar botón "Actualizar Carátula"
                      </label>
                    </span>
                    <span class="d-flex align-items-center gap-2">
                      <label>
                        <a-switch size="small" v-model="value.header.showUpdateProcedureButton" />
                        Mostrar botón "Actualizar trámite"
                      </label>
                    </span>
                    <span class="d-flex align-items-center gap-2">
                      <label>
                        <a-switch size="small" v-model="value.header.showNewPassButton" />
                        Mostrar botón "Nuevo pase"
                      </label>
                    </span>
                  </div>
                </template>
                <div class="h-25 mb-5 d-flex interactive-zone">
                  <div class="d-flex justify-content-between w-100 p-3">
                    <div class="d-flex gap-3">
                      <div>
                        <div class="shape-text mb-2"></div>
                        <div class="shape-text"></div>
                      </div>
                      <div>
                        <div class="shape-text mb-2"></div>
                        <div class="shape-text"></div>
                      </div>
                    </div>
                    <div>
                      <div class="shape-text mb-2"></div>
                      <div class="shape-text"></div>
                    </div>
                  </div>
                </div>
              </a-popover>
              <a-popover title="Documentos del trámite" :trigger="['click']">
                <template slot="content">
                  <span class="d-flex align-items-center gap-2">
                    <label>
                      <a-switch size="small" v-model="value.documents.showBuddsDocuments" />
                      Documentos BUDD
                    </label>
                  </span>
                  <span class="d-flex align-items-center gap-2">
                    <label>
                      <a-switch size="small" v-model="value.documents.showInternalsDocuments" />
                      Documentos internos
                    </label>
                  </span>
                </template>
                <div class="h-50 border interactive-zone">
                  <b-card no-body class="h-100">
                    <b-tabs card>
                      <b-tab title="Documentos BUDD" active>
                        <b-card-text>Documentos del trámite</b-card-text>
                      </b-tab>
                      <b-tab title="Documentos Internos" disabled>
                        <b-card-text>...</b-card-text>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </div>
              </a-popover>
            </div>
          </div>
          <a-popover title="Toolbar" placement="left" :trigger="['click']">
            <template slot="content">
              <div class="d-flex flex-column gap-1">
                <span class="d-flex align-items-center gap-2">
                  <label>
                    <a-switch size="small" v-model="value.toolbar.showComments" />
                    Mostrar comentarios
                  </label>
                </span>
                <span class="d-flex align-items-center gap-2">
                  <label>
                    <a-switch size="small" v-model="value.toolbar.showTags" />
                    Mostrar tags
                  </label>
                </span>
                <span class="d-flex align-items-center gap-2">
                  <label>
                    <a-switch size="small" v-model="value.toolbar.showContentTemplates" />
                    Mostrar templates de contenido
                  </label>
                </span>
                <span class="d-flex align-items-center gap-2">
                  <label>
                    <a-switch size="small" v-model="value.toolbar.showHistory" />
                    Mostrar historial
                  </label>
                </span>
                <span class="d-flex align-items-center gap-2">
                  <label>
                    <a-switch size="small" v-model="value.toolbar.showAudits" />
                    Mostrar adutoria
                  </label>
                </span>
                <span class="d-flex align-items-center gap-2">
                  <label>
                    <a-switch size="small" v-model="value.toolbar.showMovements" />
                    Mostrar movimientos
                  </label>
                </span>
                <span class="d-flex align-items-center gap-2">
                  <label>
                    <a-switch size="small" v-model="value.toolbar.showFullProcedure" />
                    Mostrar trámite completo
                  </label>
                </span>
                <span class="d-flex align-items-center gap-2">
                  <label>
                    <a-switch size="small" v-model="value.toolbar.showDownloadZip" />
                    Mostrar Zips
                  </label>
                </span>
                <span class="d-flex align-items-center gap-2">
                  <label>
                    <a-switch size="small" v-model="value.toolbar.showLinkProcedure" />
                    Mostrar Asociar trámite
                  </label>
                </span>
                <span class="d-flex align-items-center gap-2">
                  <label>
                    <a-switch size="small" v-model="value.toolbar.showNewPass" />
                    Mostrar Nuevo pase
                  </label>
                </span>
              </div>
            </template>
            <div class="col-1 border-left interactive-zone">
              <div class="d-flex flex-column py-4 p-2 gap-2">
                <div class="shape-circle"></div>
                <div class="shape-circle"></div>
                <div class="shape-circle"></div>
                <div class="shape-circle"></div>
                <hr class="w-100">
                <div class="shape-circle"></div>
                <div class="shape-circle"></div>
              </div>
            </div>
          </a-popover>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    openModal: false
  }),
  watch: {
    show: {
      immediate: true,
      handler (val) {
        this.openModal = val
      }
    }
  }
})
</script>

<style lang="sass" scoped>
.interactive-zone:hover
  outline: 5px solid rgba(37,146,218,0.15)
  outline-offset: 1px
  border-radius: 6px
  cursor: pointer

.shape-text
  width: 120px
  height: 20px
  background-color: #eaeaea
  border-radius: 4px
.shape-button
  padding: 6px 12px
  background-color: #eaeaea
  border-radius: 8px

.shape-circle
  background-color: #eaeaea
  width: 100%
  aspect-ratio: 1/1
  border-radius: 50%

label
  display: flex
  align-items: center
  gap: 0.5rem
  margin-bottom: 5px
</style>
